// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.NodeInfoManager_node-info-container__O0cGt {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding-top: 1rem;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}
@media (max-width: 1024px) {
  .NodeInfoManager_node-info-container__O0cGt {
    flex-direction: column;
  }
}

.NodeInfoManager_expander__C\\+9SU {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  color: #454545;
  cursor: pointer;
}
.NodeInfoManager_expander__C\\+9SU span {
  min-width: fit-content;
}
.NodeInfoManager_expander__C\\+9SU hr {
  border-color: #454545;
}
.NodeInfoManager_expander__C\\+9SU i {
  min-width: 1rem;
  text-align: center;
}
.NodeInfoManager_expander__C\\+9SU:hover {
  color: black;
}
.NodeInfoManager_expander__C\\+9SU:hover hr {
  border-color: black;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/NodeInfo/NodeInfoManager.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AAOF;AD+CE;EC9DF;IAUI,sBAAA;EASF;AACF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AASF;AAPE;EACE,sBAAA;AASJ;AAPE;EACE,qBAAA;AASJ;AAPE;EACE,eAAA;EACA,kBAAA;AASJ;AAPE;EACE,YAAA;AASJ;AARI;EACE,mBAAA;AAUN","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.node-info-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding-top: 1rem;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n@media (max-width: 1024px) {\n  .node-info-container {\n    flex-direction: column;\n  }\n}\n\n.expander {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  color: #454545;\n  cursor: pointer;\n}\n.expander span {\n  min-width: fit-content;\n}\n.expander hr {\n  border-color: #454545;\n}\n.expander i {\n  min-width: 1rem;\n  text-align: center;\n}\n.expander:hover {\n  color: black;\n}\n.expander:hover hr {\n  border-color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"node-info-container": `NodeInfoManager_node-info-container__O0cGt`,
	"expander": `NodeInfoManager_expander__C+9SU`
};
export default ___CSS_LOADER_EXPORT___;
